import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import GeneralAnalysisProxy from './GeneralAnalysisProxy'

class GeneralAnalysisService extends ServiceBase {
  getGenericRatioHighlight(params) {
    return this.getData(() =>
      GeneralAnalysisProxy.getGenericRatioHighlight(params),
    )
  }

  getIndustryRatioDetail(params) {
    return this.getData(() =>
      GeneralAnalysisProxy.getIndustryRatioDetail(params),
    )
  }

  getActivitiesRatioAndRisk(params) {
    return this.getData(() =>
      GeneralAnalysisProxy.getActivitiesRatioAndRisk(params),
    )
  }

  getActivitiesRatioAndRiskCompare(params) {
    return this.getData(() =>
      GeneralAnalysisProxy.getActivitiesRatioAndRiskCompare(params),
    )
  }

  getDistributeScoreChart(params) {
    return this.getData(() =>
      GeneralAnalysisProxy.getDistributeScoreChart(params),
    )
  }

  getDistributeScoreCompareChart(params) {
    return this.getData(() =>
      GeneralAnalysisProxy.getDistributeScoreCompareChart(params),
    )
  }

  getIndustryNews(params) {
    return this.getData(() => GeneralAnalysisProxy.getIndustryNews(params))
  }

  exportGeneralAnalysis(params) {
    return this.getFileDownload(() =>
      GeneralAnalysisProxy.exportGeneralAnalysis(params),
    )
  }

  getPerformanMatrixChartData(params) {
    return this.getData(() =>
      GeneralAnalysisProxy.getPerformanMatrixChartData(params),
    )
  }

  getPerformanMatrixDisplayData(params) {
    return this.getData(() =>
      GeneralAnalysisProxy.getPerformanMatrixDisplayData(params),
    )
  }
}

export default new GeneralAnalysisService()
